// extracted by mini-css-extract-plugin
module.exports = {"backgroundWhite":"Layout_backgroundWhite__14FDN","background":"Layout_background__zG5kH Layout_backgroundWhite__14FDN"};